import styled from 'styled-components'

export const Container = styled.div`
  border-top: 1px solid #dfe0e7;
  padding: 24px;
  width: 320px;
`

export const Title = styled.h3`
  font-size: 12px;
  color: #2e2e37;
  margin-bottom: 12px;
  font-weight: 600;
`
